<template>
  <div>
    <modal
      v-if="show_modal"
      :label="`${editing ? 'Edit Debrief Template' : 'Add Debrief Template'}`"
      :submit_btn_text="'Save'"
      @submit="saveTemplate($event)"
      @close="closeModal"
      blocking
      medium
      locked
    >
      <template v-slot:content>
        <AddEditDebriefTemplate v-model="item_to_edit" />
      </template>
    </modal>

    <div>
      <div data-cy="header-admin-debrief_templates">
        <h1
          class="header-text pb-3"
          ref="headerDebriefTemplates"
          aria-labelledby="header for edit debrief template page"
          data-cy="header-admin-reports-pairings"
          autofocus
        >
          Debrief Templates
        </h1>
      </div>
    </div>
    <div class="box-style">
      <div class="flex">
        <div class="flex-auto">
          <label class="mb-2" for="student-textbox-filter"> Search </label>
          <input
            id="template_filter"
            type="text"
            v-model="filterText"
            class="border-steel-gray rounded h-8 w-2/3 ml-2"
          />
        </div>
        <div class="flex-auto text-right">
          <Button class="" text="Add New" @click="show_modal = true" />
        </div>
      </div>
      <div v-if="isLoading" class="profile_box">
        <LoadingSpinner />
      </div>
      <div v-else class="profile_box">
        <div>
          <dynamic-table
            :records="this.templates"
            :fields="tableConfig"
            no-data-msg="No Debrief Templates to display"
            striped
            hover
          >
            <template #cell(display)="{ item }">
              <div
                class="ml-5 w-5 rounded-full text-center"
                :class="{
                  'bg-alert-success': item.display,
                }"
              >
                <font-awesome-icon v-if="item.display" icon="check" />
                <font-awesome-icon v-else icon="ban" />
              </div>
            </template>
            <template #cell(edit)="{ item }">
              <Button text="Edit" size="small" @click="openToEdit(item)" />
            </template>
            <template #cell(hide)="{ item }">
              <Button
                v-if="item.display"
                text="Hide"
                size="small"
                @click="hideTemplate(item)"
              />
              <Button
                v-else
                text="Show"
                size="small"
                @click="showTemplate(item)"
              />
            </template>
          </dynamic-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/reusable-components/LoadingSpinner";
import DynamicTable from "@/components/displays/admin-displays/DynamicTable";
import Button from "@/components/reusable-components/base-level-components/Button";
import AddEditDebriefTemplate from "@/views/admin/sys-administration/debrief-templates/AddEditDebriefTemplate";
import Modal from "@/components/modal/Modal";
import { del, get, post, put } from "@/composables/httpUtil";
import { emitAlert } from "@/composables/alerts";

export default {
  name: "DebriefTemplates",
  components: {
    LoadingSpinner,
    DynamicTable,
    Button,
    AddEditDebriefTemplate,
    Modal,
  },
  data() {
    return {
      isLoading: true,
      templates: [],
      filterText: "",
      show_modal: false,
      editing: false,
      item_to_edit: {
        debrief_template_id: "",
        name: "",
      },
      tableConfig: [
        {
          display: "Template Name",
          name: "name",
          sortable: false,
          class: "",
        },
        {
          display: "Displayed",
          name: "display",
          sortable: false,
          class: "",
        },
        {
          display: "Edit",
          name: "edit",
          sortable: false,
          class: "",
        },
        {
          display: "Hide / Show",
          name: "hide",
          sortable: false,
          class: "",
        },
      ],
    };
  },
  mounted() {
    this.getTemplate();
  },
  methods: {
    getTemplate() {
      let url = `admin/debrief_templates`;
      url += this.filterText !== "" ? `?name=${this.filterText}` : "";
      get(url).then((data) => {
        this.templates = data;
        this.templates.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        this.isLoading = false;
      });
    },
    openToEdit(item) {
      this.item_to_edit = item;
      this.editing = true;
      this.show_modal = true;
    },
    saveTemplate() {
      if (this.item_to_edit.name) {
        if (this.item_to_edit.debrief_template_id) {
          put(
            "admin/debrief_templates/" + this.item_to_edit.debrief_template_id,
            this.item_to_edit
          ).then((data) => {
            emitAlert("success", `${data.name} Updated`, {
              timeout: 5000,
            });
          });
        } else {
          delete this.item_to_edit.debrief_template_id;
          post("admin/debrief_templates/", this.item_to_edit).then((data) => {
            this.templates.push(data);
            this.templates.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
            emitAlert("success", `${data.name} Added`, {
              timeout: 5000,
            });
          });
        }
        this.editing = false;
        this.show_modal = false;
        this.item_to_edit = {
          template_id: "",
          name: "",
        };
      } else {
        emitAlert("error", `Name Needed`, {
          timeout: 5000,
        });
      }
    },
    hideTemplate(item) {
      item.display = false;
      del("admin/debrief_templates/" + item.debrief_template_id).then(
        (data) => {
          emitAlert("success", `${data.name} Hidden`, {
            timeout: 5000,
          });
        }
      );
    },
    showTemplate(item) {
      item.display = true;
      put("admin/debrief_templates/" + item.debrief_template_id, item).then(
        (data) => {
          emitAlert("success", `${data.name} Shown`, {
            timeout: 5000,
          });
        }
      );
    },
    closeModal() {
      this.show_modal = false;
      this.editing = false;
      this.item_to_edit = {
        debrief_template_id: "",
        name: "",
      };
    },
  },
  watch: {
    filterText: {
      handler() {
        this.getTemplate();
      },
    },
  },
};
</script>

<style scoped></style>
